import AxiosManager from "../util/axiosLib/axiosManager";

export default class apiManager {

    constructor(apiUrl,apiPathBase,methodPrefix, axiosManager,tokenCookieKey) {
        this._apiUrl = apiUrl;
        this._apiPathBase = apiPathBase;
        this._axiosManager=axiosManager;
        this._tokenCookieKey = tokenCookieKey;

        if (!(this._axiosManager) && !(this._tokenCookieKey)){
            alert('must assign once(ubossCrudApiManager)');
        }
    }

    getAxiosManager(){
        if (this._axiosManager==null){
            return new AxiosManager(this._tokenCookieKey)
        }else{
            return this._axiosManager;
        }
    }

     api_CallMethod_SendObj (methodName, objToSend)
    {
        var apiPath=this._apiPathBase +methodName;
        var data=objToSend;

        var dataReturn=   this.getAxiosManager().post_form(this._apiUrl +apiPath+'?token=' + localStorage.getItem("api_token"),data)
        return dataReturn;
    }

     api_CallMethod_ByParamObj (methodName,paramObject)
    {
        var apiPath=this._apiPathBase +methodName;
        var data=paramObject

        var dataReturn=   this.getAxiosManager().post_json(this._apiUrl +apiPath,data)
        return dataReturn;
    }

     api_CallMethod_BySystemId (methodName,systemId)
    {
        var apiPath=this._apiPathBase +methodName;
        var data= {
            systemId:systemId
        }

        var dataReturn=   this.getAxiosManager().post_json(this._apiUrl +apiPath,data)
        return dataReturn;
    }

     api_CallMethod(methodName)
    {
        var apiPath=this._apiPathBase +methodName;
        var data= {
        }

        var dataReturn=   this.getAxiosManager().post_json(this._apiUrl +apiPath,data)
        return dataReturn;
    }

     api_UpdateFile (methodName, files, paramObject)
    {
        var apiPath=this._apiPathBase +methodName;
        var data=paramObject

        var dataReturn=   this.getAxiosManager().post_files(this._apiUrl +apiPath,files,data)
        return dataReturn;
    }
}
